<template>
    <div class="box">
        <template v-if="!isshowDeviceAuth && !isshowDeviceAppType">
            <!-- 面包屑导航 -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- 搜索筛选 -->
            <h1 style="text-align: left;color: #666">当前单位：{{companyName}}</h1>
            <el-form :inline="true" class="user-search" style="text-align: left;padding-top: 20px">
                <el-form-item label="">当前单位</el-form-item>
                <el-form-item label="" prop="SearchKey">
                    <el-select v-model="companyModel.SearchKey" @change="handleSearchCompany" filterable remote reserve-keyword placeholder="请输入单位查询" 
                    :remote-method="remoteMethod2" :disabled="isdisabled">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in companyList" :key="item.OID" :label="item.Name" :value="item.OID">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" prop="SearchKey">
                    <el-form-item label="">设备类型</el-form-item>
                    <el-select v-model="deviceModel.DeviceType" placeholder="请选择" @change="handleDeviceTypeChange">
                        <el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" prop="SearchKey">
                    <el-input placeholder="请输入关键词" v-model="deviceModel.SearchKey" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="" prop="SearchKey">
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-plus" @click="handleAdd()">添加设备</el-button>
                </el-form-item>
            </el-form>
            <!-- 列表 -->
            <el-table border default-expand-all :data="dataList" style="width: 100%" @selection-change="selectChange" highlight-current-row :default-sort="{prop: 'date', order: 'descending'}">
                <el-table-column align="center" type="selection" width="50">
                </el-table-column>
                <el-table-column prop="OID" label="ID" sortable width="100">
                </el-table-column>
                <el-table-column prop="DeviceCode" label="设备编码" sortable width="300">
                </el-table-column>
                <el-table-column prop="DeviceName" label="设备名称" sortable width="180">
                </el-table-column>
                <el-table-column prop="DeviceType" label="设备类型" sortable width="180">
                </el-table-column>
                <el-table-column prop="CreateTime" label="添加时间" sortable width="180">
                </el-table-column>
                <el-table-column prop="ApplicationVersionName" label="产品名称" sortable width="180">
                </el-table-column>
                <el-table-column prop="Status" label="设备状态" sortable width="180">
                </el-table-column>
                <el-table-column prop="ProducerNmae" label="出品单位" sortable width="180">
                </el-table-column>
                <el-table-column label="操作" min-width="300" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" @click="handleSetting(scope.row)">设备配置项</el-button>
                        <el-button size="mini" type="info" @click="handleAuth(scope.row)">设备应用授权</el-button>
                        <el-button size="mini" type="success" @click="handleCate(scope.row)" v-if="scope.row.OID!=1">设备应用分类</el-button>
                        <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-if="scope.row.OID!=1">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-row style="text-align: left;padding-top: 10px">
                <el-pagination background @current-change="handleCurrentChange" :current-page="deviceModel.Page" layout="total,prev, pager, next, jumper" :total="listCount" :page-size="deviceModel.Rows">
                </el-pagination>
            </el-row>
            <add v-if="isShowAdd" :dialogFormVisible="isShowAdd" @closeAddDialog="handleCloseAdd" :CompanyID="deviceModel.CompanyID" :companyName="companyName"></add>
            <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :data="editData" :companyName="companyName"></edit>
            <setting v-if="isShowSetting" :dialogFormVisible="isShowSetting" @closeSettingDialog="handleCloseSetting" :OID="deviceOID"></setting>
        </template>
        <deviceAppAuthManage v-if="isshowDeviceAuth" :companyName="companyName" :id="id" :deviceName="deviceName" :DeviceCode="DeviceCode" :CompanyCode="CompanyCode" :deviceType="deviceType" :CompanyID="deviceModel.CompanyID" @showDevice="handleShowDevice"></deviceAppAuthManage>
        <deviceAppTypeManage v-if="isshowDeviceAppType" :companyName="companyName" :id="id" :deviceName="deviceName" :CompanyID="deviceModel.CompanyID" :DeviceCode="DeviceCode" :CompanyCode="CompanyCode" @showDevice="handleShowDeviceAppType"></deviceAppTypeManage>
    </div>
</template>

<script>
    import { GetDeviceList, DeleteDevice } from '../../api/device'
    import { GetCompanyList } from '../../api/company'
    import add from './add'
    import edit from './edit'
    import setting from './setting'
    import deviceAppAuthManage from './deviceAppAuthManage/list'
    import deviceAppTypeManage from './deviceTypeManage/list'
    import { Row } from 'element-ui'
    export default {
        components: {
            add,
            edit,
            setting,
            deviceAppAuthManage,
            deviceAppTypeManage
        },
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                isShowSetting: false,
                listCount: null,
                dataList: [],
                editData: [],
                isdisabled: false,
                CompanyID: null,
                deviceOID: null,
                companyName: '',
                DeviceCode: '',
                isshowDeviceAuth: false,
                isshowDeviceAppType: false,
                deviceModel: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                    CompanyID: 0,
                    DeviceType: null
                },
                companyModel: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                },
                companyList: [],
                deviceTypeList: [{
                        label: '全部',
                        value: ''
                    }, {
                        label: 'android',
                        value: 'android'
                    },
                    {
                        label: 'web',
                        value: 'web'
                    },
                    {
                        label: 'dingding',
                        value: 'dingding'
                    },
                    {
                        label: 'windows',
                        value: 'windows'
                    },

                    {
                        label: 'ios',
                        value: 'ios'
                    },
                ],
                deviceName: '',
                id: null,
                deviceType: '',
                deviceId: Number,

            }
        },
        watch: {
            'deviceModel.SearchKey': {
                handler(newVal, oldVal) {
                    if (newVal === '') {
                        this.deviceModel.SearchKey = '';
                        this.GetDeviceList();
                    }
                }
            }
        },
        mounted() {
            GetCompanyList(this.companyModel).then(data => {
                if (!data.iserror) {
                    this.companyList = data.data.List;
                    if (this.$route.query.CompanyID) {
                        this.deviceModel.CompanyID = this.$route.query.CompanyID;
                        this.companyModel.SearchKey = this.$route.query.CompanyID;
                    } else {
                        this.deviceModel.CompanyID = this.companyList[0].OID;
                        this.companyModel.SearchKey = this.companyList[0].OID;
                    }
                    this.companyList.forEach(item => {
                        if (item.OID === this.deviceModel.CompanyID) {
                            this.companyName = item.Name
                        }
                    })
                    console.log(this.companyName)
                    this.GetDeviceList();
                }
            })
        },
        methods: {
            handleSearchCompany(val) {
                console.log(val)
                if (val == 0) {
                    this.companyName = '全部';
                } else {
                    this.companyList.forEach(item => {
                        if (item.OID === val) {
                            this.companyName = item.Name
                        }
                    })
                }
                this.deviceModel.CompanyID = val;
                this.deviceModel.Page = 1;
                this.GetDeviceList();
            },
            remoteMethod2(query) {
                this.companyModel.SearchKey = query;
                this.GetCompanyList();
            },
            GetCompanyList() {
                GetCompanyList(this.companyModel).then(data => {
                    if (!data.iserror) {
                        this.companyList = data.data.List;
                    }
                })
            },
            GetDeviceList() {
                GetDeviceList(this.deviceModel).then(data => {
                    if (!data.iserror) {
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleCurrentChange(val) {
                this.deviceModel.Page = val;
                this.GetDeviceList();
            },
            selectChange(val) {
                this.selectdata = val
            },
            handleSearch() {
                if (this.deviceModel.SearchKey === '') {
                    this.$message({
                        message: '搜索内容不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                this.deviceModel.Page = 1;
                this.deviceModel.SearchKey = this.deviceModel.SearchKey.trim();
                this.GetDeviceList();
            },
            handleAdd() {
                // if(this.deviceModel.CompanyID != 1) {
                //     this.CompanyID = this.deviceModel.CompanyID;
                //     this.isShowAdd = true;
                // }else{
                //     this.$message({
                //         message: '请先选择要添加设备的单位',
                //         type: 'warning'
                //     });
                // }
                this.CompanyID = this.deviceModel.CompanyID;
                console.log(this.companyName)
                this.isShowAdd = true;
            },
            handleEdit(row) {
                this.editData = row;
                this.isShowEdit = true;
            },
            handleCloseAdd() {
                this.isShowAdd = false;
                this.GetDeviceList();
            },
            handleCloseEdit() {
                this.isShowEdit = false;
                this.GetDeviceList();
            },
            handleCloseSetting() {
                this.isShowSetting = false;
            },
            handleDelete(row) {
                let id = row.OID;
                this.$confirm('确认要删除该设备吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.DeleteDevice(id);
                })
            },
            DeleteDevice(id) {
                DeleteDevice({ OID: id }).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.GetDeviceList();
                    }
                })
            },
            handleSetting(row) {
                this.deviceOID = row.OID;
                this.isShowSetting = true;
            },
            handleAuth(row) {
                console.log(row.DeviceType)
                this.id = row.OID;
                this.deviceName = row.DeviceName;
                this.deviceType = row.DeviceType;
                this.DeviceCode = row.DeviceCode;
                this.CompanyCode = row.CompanyCode;
                this.deviceId = row.OID;
                this.isshowDeviceAuth = true;
            },
            handleCate(row) {
                console.log(row)
                this.deviceName = row.DeviceName;
                // this.deviceType = row.DeviceType;
                this.DeviceCode = row.DeviceCode;
                this.CompanyCode = row.CompanyCode;
                this.isshowDeviceAppType = true;
            },
            handleDeviceTypeChange(val) {
                this.deviceModel.Page = 1;
                this.GetDeviceList();
            },
            handleShowDevice(data) {
                this.isshowDeviceAuth = false;
                this.deviceAppTypeManage = false;
            },
            handleShowDeviceAppType() {
                this.isshowDeviceAppType = false;
                this.isshowDeviceAuth = false;
            }
        }
    }
</script>

<style>

</style>